<div class="pt-100">
    <div class="title-breadcumbs">
        <div class="container">
            <div class="entry-header">
                <h2 class="entry-title">{{'label-title.privacy-policy' | translate}}</h2>
            </div>
            <div class="breadcrumb-container">
                <div class="breadcrumbs">
                    <a href="javascript:;">{{'label-title.home' | translate}}</a><span class="separator">&gt;</span><span>
                        {{'label-title.privacy-policy' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="policy">
    <div class="container">
        <h4>{{'heading-title.what-personal-data-we-collect-and-why-we-collect-it' | translate}}</h4>
        <h5>{{'heading-title.comments' | translate}}</h5>
        <p class="mb-4">{{'paragraph-title.privacy-comments' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-gravatar' | translate}}</p>
        <h5>{{'heading-title.media' | translate}}</h5>
        <p class="mb-4">{{'paragraph-title.privacy-media' | translate}}</p>
        <h5>{{'heading-title.cookies' | translate}}</h5>
        <p class="mb-4">{{'paragraph-title.privacy-cookies-1' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-cookies-2' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-cookies-3' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-cookies-4' | translate}}</p>
        <h5>{{'heading-title.embedded-content-from-other-websites' | translate}}</h5>
        <p class="mb-4">{{'paragraph-title.privacy-embedded-content-1' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-embedded-content-2' | translate}}</p>

        <h4>{{'heading-title.how-long-we-retain-your-data' | translate}}</h4>
        <p class="mb-4">{{'paragraph-title.privacy-retain-1' | translate}}</p>
        <p class="mb-4">{{'paragraph-title.privacy-retain-2' | translate}}</p>
        <h4>{{'heading-title.what-rights-you-have-over-your-data' | translate}}</h4>
        <p class="mb-4">{{'paragraph-title.privacy-rights' | translate}}</p>
        <h4>{{'heading-title.where-we-send-your-data' | translate}}</h4>
        <p class="mb-4">{{'paragraph-title.privacy-where-send-data' | translate}}</p>
    </div>
</div>
